ixModuleRouting(
    'impactx.purchaseorder',
    {
        '/purchaseorderdetail/:id?/:printId?': {
            template: '<ixa-purchase-order-detail></ixa-purchase-order-detail>',
            templateUrl: 'modules/purchaseorder/templates/purchaseorderdetail.tmpl.html',
            controller: 'PurchaseOrderDetailCtrl',
            controllerAs: 'purchaseOrderDetailCtrl',
            process: 'PurchaseOrderView',
            workspace: 'shop',
        },
        '/purchaseorderdetailsupplier/:id/:printId?': {
            template: '<ixa-purchase-order-supplier-detail></ixa-purchase-order-supplier-detail>',
            templateUrl:
                'modules/purchaseorder/templates/purchaseorderdetail.tmpl.html',
            process: 'PurchaseOrderSupplier',
            controller: 'PurchaseOrderSupplierDetailCtrl',
            controllerAs: 'purchaseOrderDetailCtrl',
            workspace: 'shop',
        },
        '/purchaseorderlist': {
            template: '<ixa-purchase-order-list></ixa-purchase-order-list>',
            templateUrl: 'modules/purchaseorder/templates/purchaseorderlist.tmpl.html',
            controller: 'PurchaseOrderListCtrl',
            controllerAs: 'purchaseOrderListCtrl',
            process: 'PurchaseOrderList',
            workspace: 'shop',
        },
        '/purchaseorderlistaddressrelated': {
            template: '<ixa-purchase-order-address-related-list></ixa-purchase-order-address-related-list>',
            templateUrl:
                'modules/purchaseorder/templates/purchaseorderlist.tmpl.html',
            process: 'PurchaseOrderListAddressRelated',
            controller: 'PurchaseOrderAddressRelatedListCtrl',
            controllerAs: 'purchaseOrderListCtrl',
            workspace: 'shop',
        },
        '/purchaseordersupplierlist': {
            template: "<ixa-purchase-order-supplier-list></ixa-purchase-order-supplier-list>",
            templateUrl:
                'modules/purchaseorder/templates/purchaseordersupplierlist.tmpl.html',
            process: 'PurchaseOrderSupplier',
            controller: 'PurchaseOrderSupplierListCtrl',
            controllerAs: 'purchaseOrderSupplierListCtrl',
            workspace: 'shop',
        },
        '/acceptpohsupplier/:osutan': {
            template: '<ixa-purchase-order-supplier-accept></ixa-purchase-order-supplier-accept>',
            templateUrl: 'modules/purchaseorder/templates/pohsupplieraccept.tmpl.html',
            noSecurity: true,
            controller: 'PurchaseOrderSupplierAcceptCtrl',
            controllerAs: 'purchaseOrderSupplierAcceptCtrl',
            workspace: 'shop',
        },
        '/purchaseorderitemlist': {
            template: '<ixa-purchase-order-item-list></ixa-purchase-order-item-list>',
            templateUrl: 'modules/purchaseorder/templates/purchaseorderitemlist.tmpl.html',
            process: 'PurchaseOrderList',
            controller: 'PurchaseOrderItemListCtrl',
            controllerAs: 'purchaseOrderItemListCtrl',
            workspace: 'shop',
        },
       '/purchaseorderlistmaster': {
            template: '<ixa-purchase-order-list-master></ixa-purchase-order-list-master>',
            process: 'PurchaseOrderListMaster',
            workspace: 'shop',
        },
    },
    ['ngRoute', 'impactx.list', 'impactx.statusicon', 'impactx.item']
);
